import { PropTypes } from "prop-types";

import { DistributionsList } from "@/components";

const ReleaseDetailsDistributions = ({ releaseId }) => <DistributionsList releaseId={releaseId} />;

export default ReleaseDetailsDistributions;

ReleaseDetailsDistributions.propTypes = { releaseId: PropTypes.string };
